export default {
    namespaced: true,
    state: {
        invoice: ""
    },

    actions: {

        add: ({rootState}, note) => {
            return new Promise((resolve, reject) => {
                rootState.init.http_common.post('/facturar', JSON.stringify(note))
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        downloadXml:({rootState}, uuid) => {
            return new Promise((resolve, reject) => {
                rootState.init.http_common.get(`/cfdis/${uuid}/xml?download=true`, {responseType: 'blob'})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadPdf:({rootState}, uuid) => {
            return new Promise((resolve, reject) => {
                rootState.init.http_common.get(`/cfdis/${uuid}/pdf?download=true`, {responseType: 'blob'})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

    }

}
